
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    disabled: {
      default: false,
      type: Boolean
    },

    size: {
      default: '',
      type: String
    }
  },

  setup (props) {
    const buttonCss: string[] = []

    if (props.disabled) {
      buttonCss.push('pointer-events-none opacity-75 cursor-')
    }

    switch (props.size) {
      case 'xl':
        buttonCss.push('py-4 px-6 rounded-md')
        break
      case 'lg':
        buttonCss.push('py-3 px-5 rounded-md')
        break
      default:
        buttonCss.push('py-2 px-4 rounded text-sm')
        break
    }

    return {
      buttonCss
    }
  }
})
